// extracted by mini-css-extract-plugin
module.exports = {"title":"Map_title__3qZ7F","address":"Map_address__25n5B","rating":"Map_rating__FXvD3","popup":"Map_popup__e4g3w"};